/**
 * @fileoverview Review request list query hook.
 * @description Wraps GET /approvals (every page) in a TanStack query, keyed by its filters.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getAllApprovalRequests } from '@/features/sales/services/approvals.service'

import type { ApprovalListFilters } from '@/features/sales/types/approval.types'

/**
 * @description Fetches the review requests matching the filters.
 * @param {ApprovalListFilters} filters - Whose requests, and in which state.
 * @returns {ReturnType<typeof useQuery>} The query (data is every matching request).
 */
export function useApprovalRequests(filters: ApprovalListFilters) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.approvals(filters),
    queryFn: () => getAllApprovalRequests(filters),
  })
}
